// src/services/visitesServices.js
import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/visites`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");

  if (!token) {
    return {};
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

/// GET

export const countVisites = async () => {
  try {
    const response = await axios.get(`${apiUrl}/countVisites`, {
      headers: getAuthHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la récupération du nombre de visites :",
      error
    );
    throw error;
  }
};

export const countVisitesByDate = async (params = {}) => {
  try {
    const response = await axios.get(`${apiUrl}/countVisitesByDate`, {
      headers: getAuthHeaders(),
      params,
    });

    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la récupération du nombre de visites par date :",
      error
    );
    throw error;
  }
};

export const countVisitesByPage = async (params = {}) => {
  try {
    const response = await axios.get(`${apiUrl}/countVisitesByPage`, {
      headers: getAuthHeaders(),
      params,
    });

    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la récupération du nombre de visites par page :",
      error
    );
    throw error;
  }
};

export const countVisitesByPageByDate = async (params = {}) => {
  try {
    const response = await axios.get(`${apiUrl}/countVisitesByPageByDate`, {
      headers: getAuthHeaders(),
      params,
    });

    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la récupération du détail des visites par page :",
      error
    );
    throw error;
  }
};

/// POST

export const saveVisite = async ({ page_path = "home", page_label = "" } = {}) => {
  try {
    const response = await axios.post(`${apiUrl}/addVisite`, {
      page_path,
      page_label,
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'enregistrement de la visite :", error);
    throw error;
  }
};

/// DELETE

export const deleteVisitesByDate = async (dateDebut, dateFin, page_path = null) => {
  try {
    const response = await axios.delete(`${apiUrl}/deleteVisites`, {
      headers: getAuthHeaders(),
      data: {
        dateDebut,
        dateFin,
        page_path,
      },
    });

    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la suppression des visites par date :",
      error
    );
    throw error;
  }
};